import React from 'react';
import BrandDetailNoticeProductList from '../BrandDetailNoticeProductList';
import { useBrandDetailNoticeProduct } from '../../../../../hooks/brand/detail/useBrandDetailNoticeProduct';

const BrandDetailNoticeProductSection = ({ storeId }) => {
  const { listInfo, summary, getBrandDetailNoticeProduct, getBrandDetailNoticeExcelDownload } =
    useBrandDetailNoticeProduct(storeId);

  return (
    <div className="brand-detail-notice-product-section">
      {/*상품 공지사항 리스트*/}
      <BrandDetailNoticeProductList
        summary={summary}
        listInfo={listInfo}
        getList={getBrandDetailNoticeProduct}
        getBrandDetailNoticeExcelDownload={getBrandDetailNoticeExcelDownload}
      />
    </div>
  );
};

export default BrandDetailNoticeProductSection;
